import { useMutation } from '@tanstack/react-query'
import type { PhotoActionStore } from '../../store/PhotoActionStore'
import { usePhotoStore } from '../../store/PhotoContext'
import type { PhotoAction, PhotoActionType } from './PhotoActions.types'

export type PhotoActionDispatcher = PhotoActionStore['dispatch']
export type OnPhotoActionDispatch = <A extends PhotoActionType>(
  actionType: A extends PhotoActionType ? A : never,
  ...args: PhotoAction<typeof actionType>['params']
) => false | undefined | void
export type OnPhotoActionDispatchError = <A extends PhotoActionType>(
  actionType: A extends PhotoActionType ? A : never,
  error: unknown,
) => false | undefined | void

export function useDispatchPhotoActionMutation<A extends PhotoActionType>(
  actionType: A extends PhotoActionType ? A : never,
  options?: Partial<PhotoAction<typeof actionType>['useMutationOptions']>,
  dispatch?: PhotoActionDispatcher,
) {
  type Action = PhotoAction<A>
  const store = usePhotoStore()
  return useMutation<Action['result'], unknown, Action['params'], unknown>({
    mutationFn: args =>
      (dispatch || store.actions.dispatch)(actionType, ...args),
    ...options,
  })
}
